// Google Analytics 4 Event Tracking via Data Attributes

export const initEventTracking = () => {

  if (typeof gtag === 'undefined') {
    console.warn('gtag not found - GA4 events will not be tracked')
    // return
  }

  function trackFormSubmission(form) {
    const eventCategory = form.parentElement.getAttribute('data-ga-category')
    const eventName = form.parentElement.getAttribute('data-ga-event')
    const eventLabel = form.parentElement.getAttribute('data-ga-label')

		// alert('form.id: ' + form.id)
		// alert('form.name: ' + form.name)
		// alert('eventCategory: ' + eventCategory)
		// alert('eventName: ' + eventName)
		// alert('eventLabel: ' + eventLabel)

    if (eventCategory && eventName) {
      gtag('event', eventName, {
        event_category: eventCategory,
        event_label: eventLabel || '',
        form_id: form.id || '',
        form_name: form.name || '',
      })
    }
  }

  function trackClick(element) {
    const eventCategory = element.getAttribute('data-ga-category')
    const eventName = element.getAttribute('data-ga-event')
    const eventLabel = element.getAttribute('data-ga-label')

		// console.log(eventCategory, eventName, eventLabel)

    if (eventCategory && eventName) {
      gtag('event', eventName, {
        event_category: eventCategory,
        event_label: eventLabel || '',
        link_text: element.textContent.trim(),
        link_url: element.href || '',
      })
    }
  }

  // Set up form tracking
  document.addEventListener('submit', function (e) {
    const form = e.target
		console.log(form.parentElement)
    if (form.parentElement.hasAttribute('data-ga-event')) {
      trackFormSubmission(form)
    }
  })

  // Set up click tracking
  document.addEventListener('click', function (e) {
    const element = e.target.closest('[data-ga-event]')
    if (element && element.tagName !== 'FORM' && element.id !== 'form') {
      trackClick(element)
    }
  })

  console.log('GA4 event tracking initialized')
}

export default () => { }

/* ============================================
   RECOMMENDED GA4 EVENT STRUCTURE
   ============================================
   
   For consistency across your reports, use:
   
   FORMS:
   - Category: "form_submission"
   - Event: "[form_type]_submit"
   - Label: Specific identifier (page, content title, etc)
   
   CLICKS:
   - Category: "engagement" | "contact" | "navigation"
   - Event: "[action]_click"
   - Label: Location or specific identifier
   
   ============================================ */
